import { StyleSheet } from '@react-pdf/renderer';

export const styles = StyleSheet.create({
  page: {
    padding: 30,
    fontFamily: 'Helvetica',
    fontSize: 10,
    color: '#333',
  },
  header: {
    width: '100%',
    marginBottom: 10,
    alignItems: 'center',
    paddingBottom: 10,
    borderBottomWidth: 1,
    borderStyle: 'solid',
    borderColor: '#CBD5E1',
  },
  headerTop: {
    flexDirection: 'row',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 5,
  },
  logoContainer: {
    flex: 1,
    paddingRight: 8,
  },
  logoImage: {
    width: '60%',
    objectFit: 'contain',
  },
  infoCenter: {
    flex: 2,
    flexDirection: 'column',
    alignItems: 'center',
    gap: 4,
  },
  metaDataHeaderWrapper: {
    flex: 1,
    alignItems: 'flex-end',
  },
  metaDataHeader: {
    fontSize: 10,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    borderLeftWidth: 1,
    borderStyle: 'solid',
    borderColor: '#CBD5E1',
    paddingLeft: 8,
    gap: 2,
  },
  name: {
    fontSize: 14,
    fontWeight: 'bold',
    textTransform: 'uppercase',
    color: '#003366',
  },
  titleHeader: {
    fontSize: 16,
    fontWeight: 'bold',
    marginBottom: 5,
  },
  metaDataContainer: {
    flexDirection: 'row',
    width: '100%',
    justifyContent: 'space-between',
    marginTop: 10,
  },
  metaDataColumnLeft: {
    flexDirection: 'column',
    width: '65%',
  },
  metaDataColumnRight: {
    flexDirection: 'column',
    width: '32%',
  },
  metaDataText: {
    fontSize: 10,
    marginBottom: 6,
  },
  labelBold: {
    fontFamily: 'Helvetica-Bold',
  },
  headerText: {
    fontSize: 9,
    color: '#555',
  },
  title: {
    fontSize: 16,
    fontWeight: 'bold',
    textAlign: 'center',
    marginVertical: 10,
  },
  occurrenceBlock: {
    marginBottom: 15,
    padding: 10,
    backgroundColor: '#f9f9f9',
    borderRadius: 4,
    borderWidth: 1,
    borderColor: '#e0e0e0',
  },
  occurrenceHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    borderBottomWidth: 1,
    borderBottomColor: '#eee',
    paddingBottom: 5,
    marginBottom: 5,
  },
  occurrenceTitle: {
    fontSize: 11,
    fontWeight: 'bold',
    color: '#003366',
  },
  grid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  gridItem: {
    width: '50%',
    marginBottom: 4,
  },
  label: {
    fontWeight: 'bold',
    fontSize: 9,
    color: '#666',
  },
  value: {
    fontSize: 10,
  },
  photoContainer: {
    marginTop: 10,
    alignItems: 'center',
  },
  photo: {
    maxWidth: 250,
    maxHeight: 250,
    objectFit: 'contain',
    borderRadius: 4,
  },
  footer: {
    position: 'absolute',
    bottom: 20,
    left: 0,
    right: 0,
    textAlign: 'center',
    fontSize: 8,
    color: '#888',
  },
});
